import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import DoctorModal from './DoctorModal';
import Button from '@mui/material/Button';
import '../../../App.css';


const theme = createTheme({

    overrides: {

    }
});

export default function DoctorCard(props) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
        <ThemeProvider theme={theme}>
            <DoctorModal showBottomButtons={props.showBottomButtons} color={props.color} handleClose={handleClose} open={open} handleOpen={handleOpen} />

            <div className="doctor-card-container-div" style={{
                borderColor:props.color?props.color:"#707070"
            }}>
                <div style={{ minWidth: '400px', flex: 1, display: 'flex', textAlign: 'right', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'stretch' }}>
                    <div style={{ flex: 4, display: 'flex', textAlign: 'right', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'right', }}>

                        <div style={{ marginTop: 10, display: 'flex', textAlign: 'right', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                            <img
                                src={`${require('../../../assets/imgs/doctor.png')}`}
                                alt={"دكتور"}
                                loading="lazy"
                                width={"40px"}
                            />
                            <h5 style={{ width: '100%', marginRight: '10px', color: '#52676F', fontSize: '14px' }}>بان سيف احمد</h5>
                            <h6 style={{ width: '100%', marginRight: '10px', color: '#52676F', fontSize: '14px' }}>دكتورة تجميل</h6>


                        </div>
                        <div style={{ marginTop: 10, display: 'flex', textAlign: 'right', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                            <img
                                src={`${require('../../../assets/imgs/telephone.png')}`}
                                alt={"دكتور"}
                                loading="lazy"
                                width={"40px"}
                            />
                            <h6 style={{ width: '100%', marginRight: '10px', color: '#52676F', fontSize: '14px', direction: 'ltr' }}>+964 (770) 000-0000</h6>

                        </div>
                        <div style={{ marginTop: 10, display: 'flex', textAlign: 'right', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                            <img
                                src={`${require('../../../assets/imgs/mapit.png')}`}
                                alt={"دكتور"}
                                loading="lazy"
                                width={"40px"}
                            />
                            <h6 style={{ width: '100%', marginRight: '10px', color: '#52676F', fontSize: '14px' }}>بغداد - الحارثية شارع الكندي</h6>

                        </div>
                        {!props.paid ?
                            <div style={{ marginTop: 20, display: 'flex', textAlign: 'right', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                                <img
                                    src={`${require('../../../assets/imgs/coins_iqd.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h6 style={{ width: '100%', marginRight: '10px', color: '#52676F', fontSize: '14px' }}>1,800,000 دينار عراقي</h6>

                            </div>
                            : null}
                    </div>
                    <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>


                        <img
                            src={`${require('../../../assets/imgs/doctor_female.jpg')}`}
                            alt={"دكتور"}
                            loading="lazy"
                            width={"100px"}

                            style={{
                                borderRadius: '14px',
                                borderColor: props.color?props.color:'#707070',
                                borderWidth: 3,
                                borderStyle: 'solid',
                                marginBottom: 15
                            }}
                        />
                        {props.paid ?
                            <Button variant="contained"
                                sx={{
                                    fontFamily: " 'Tajawal', sans-serif",
                                    backgroundColor: '#1E824C',
                                    color: '#fff',
                                    fontSize: '20px',

                                    minWidth: '130px',
                                    paddingTop: '2px',
                                    paddingBottom: '2px',
                                    '&:hover': {
                                        backgroundColor: '#FFFFFF',
                                        color: '#1E824C',
                                    },
                                    borderRadius: '15px',
                                    borderColor: props.color?props.color:'#707070',
                                    borderWidth: 1,
                                    borderStyle: 'solid',
                                    boxShadow: '0 0 0 0'
                                }}>
                                تم السداد
                            </Button>
                            :
                            <Button variant="contained"
                                sx={{
                                    fontFamily: " 'Tajawal', sans-serif",
                                    backgroundColor: '#CF000F',
                                    color: '#fff',
                                    fontSize: '20px',
                                    minWidth: '130px',
                                    paddingTop: '2px',
                                    paddingBottom: '2px',
                                    '&:hover': {
                                        backgroundColor: '#FFFFFF',
                                        color: '#CF000F',
                                    },
                                    borderRadius: '15px',
                                    borderColor: props.color?props.color:'#707070',
                                    borderWidth: 1,
                                    borderStyle: 'solid',
                                    boxShadow: '0 0 0 0'
                                }}>
                                مطلوب
                            </Button>
                        }


                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <Button variant="contained"
                        onClick={() => { setOpen(true) }}
                        sx={{
                            fontFamily: " 'Tajawal', sans-serif",
                            backgroundColor: props.color?props.color:'#59776E',
                            color: '#fff',
                            fontSize: '20px',
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingRight: 5,
                            paddingLeft: 5,

                            flex: 1,
                            '&:hover': {
                                backgroundColor: '#FFFFFF',
                                color: props.color?props.color:'#59776E',
                            },
                            borderRadius: '20px',
                            borderColor: props.color?props.color:'#707070',
                            borderWidth: 1,
                            borderStyle: 'solid',
                            boxShadow: '0 0 0 0'
                        }}>
                        عرض التفاصيل
                        </Button>
                </div>
            </div>

        </ThemeProvider>
    );
}




